<template>
    <div class="p-4">
        <div>
            <div class="grid sm:grid-cols-2 lg:grid-cols-2 gap-4 mb-3 text-center">
                <CardDefault @click="$router.push('/user')">
                    <img src="../assets//user-account.png"  class="w-full h-80 object-cover rounded-xl" />
                    <div class="p-2">
                        <h1 class="text-2xl text-white font-semibold">Users</h1>
                        <div class="mb-3 text-xl text-white">Pending: {{ users.pending }} | Available: {{ users.available }} | Suspended: {{ users.suspended }}</div>
                    </div>
                </CardDefault>
                <CardDefault @click="$router.push('/event')">
                    <img src="../assets/it-showcase-event.jpg"  class="w-full h-80 object-cover rounded-xl" />
                    <div class="p-2">
                        <h1 class="text-2xl text-white">IT Showcase Events</h1>
                        <div class="mb-3 text-xl text-white">Not Ready: {{ itShowcaseEvents.not_ready }} | Ready: {{ itShowcaseEvents.ready }} | Ended: {{ itShowcaseEvents.ended }}</div>
                    </div>
                </CardDefault>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'HomeView',
    components: {

    },
    data() {
        return {
            users: {
                pending: '-',
                available: '-',
                suspended: '-',
            },
            itShowcaseEvents: {
                not_ready: '-',
                ready: '-',
                ended: '-',
            },
        };
    },

    mounted() {
        this.retrieveData();
    },

    methods: {
        async retrieveData() {
            const response = await this.httpRequest('/organizer/dashboard', 'get');
            if (response.result === 'success') {
                const data = response.data;
                this.users = {...data.users}
                this.itShowcaseEvents = {...data.itShowcaseEvents};
            }
        }
    }
}
</script>
